import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_ITEM_OPTION } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { UUID } from "src/types/shared.type";
import { ModifierItemOption } from "src/interfaces/modifier.interface";
import { useModifierItemsByCategoryCorrelationId } from "./useModifierItemsByCategoryCorrelationId";

export const useDeleteModifierItemOption = () => {
  const { axBe } = useAxiosInterceptor();
  const { fetchModifierItemsByCategoryCorrelationId } = useModifierItemsByCategoryCorrelationId();

  const [isDeletingModifierItemOption, setIsDeletingModifierItemOption] = useState(false);

  const deleteModifierItemOptionMutation = useCallback(
    async (correlationId: UUID) => {
      setIsDeletingModifierItemOption(true);
      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: UPDATE_MODIFIER_ITEM_OPTION,
          variables: {
            updateModifierItemOptionInput: {
              modifierItemOptionCorrelationId: correlationId,
              isActive: false,
            },
          },
        });

        if (data?.data?.updateModifierItemOption) {
          successToast("Modifier item option has been deleted successfully!");         
          await fetchModifierItemsByCategoryCorrelationId();
        }
      } catch (err) {
        console.error("Error deleting modifier item option:", err);
      } finally {
        setIsDeletingModifierItemOption(false);
      }
    },
    [axBe, fetchModifierItemsByCategoryCorrelationId]
  );

  // Function to handle deletion based on whether option exists in database
  const handleDeleteModifierItemOption = useCallback(async (
    modifierItemOption: ModifierItemOption,
    onRemoveModifierItemOptionFromUI: (modifierItemOptionIndex: number) => void,
    modifierItemOptionIndex: number
  ) => {
    if (modifierItemOption.correlationId) {
      await deleteModifierItemOptionMutation(modifierItemOption.correlationId);
    } else {
      onRemoveModifierItemOptionFromUI(modifierItemOptionIndex);
    }
  }, [deleteModifierItemOptionMutation]);

  return {
    isDeletingModifierItemOption,
    handleDeleteModifierItemOption,
  };
};
